module.exports = __webpack_public_path__ + "static/toggl-track-b0b111b1afcf450aa4d880807df481e6.svg";